// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1yYk9","label":"Radio_label__36hYA","checkMark":"Radio_checkMark__37zZi","disabled":"Radio_disabled__3j3oB"};